import * as Dto from '_models/dtos';

export class SessionData {
    constructor() {
        this.region = null;
        this.wizard = new WizardSessionData();
        this.locations = [];
        this.allSelectedProducts = [];
        this.schedule = [];
    }

    region: Dto.Region;

    wizard: WizardSessionData;

    locations: string[];

    /**
     * An array of all product-color selections.
     * Selections will be added to this at the end of each wizard pass.
     */
    allSelectedProducts: Dto.WizardProductColorSelection[];

    /**
     * An array of product-color-room selections.
     * Selections will be add here when product-color selections are added to a room.
     */
    schedule: Dto.ScheduleItem[];

    addWizardSelections() {
        this.wizard.selectedColors.map(wizardSelectedColor => {
            // Combine wizard selected colors with wizard selected product
            return new Dto.WizardProductColorSelection(this.wizard.selectedProductUse, this.wizard.selectedSubstrate, this.wizard.selectedProduct, wizardSelectedColor);
        }).filter(item => {
            // Filter out selections that already exist
            var exists = this.allSelectedProducts.some(s =>
                s.color.colorUID == item.color.colorUID &&
                s.product.productFamily == item.product.productFamily && 
                s.sheenName == item.sheenName);
            return !exists;
        }).forEach(item => {
            // Add to global selections
            this.allSelectedProducts.push(item);
        });
    }

    resetWizard() {
        this.wizard = new WizardSessionData();
    }
    
    save() {
        try {
            console.info('saving session data...');
            var sdJson = JSON.stringify(this);
            window.sessionStorage.setItem('sd', sdJson);
        } catch (ex) {
            console.warn('unable to save session data');
        }
    }

    load() {
        try {
            console.info('loading session data...');
            var sdJson = window.sessionStorage.getItem('sd');
            if (sdJson) {
                var sd = JSON.parse(sdJson);

                // Strongly type json <any> objects
                Object.assign(this, sd);
                this.allSelectedProducts = this.allSelectedProducts.map(p => new Dto.WizardProductColorSelection(p.productUse, p.substrate, p.product, p.color));
                this.schedule = this.schedule.map(s => new Dto.ScheduleItem(s.productUse, s.substrate, s.product, s.color, s.location, s.notes));

                this.wizard = new WizardSessionData(sd.wizard);
            }
        } catch (ex) {
            console.warn('unable to load session data');
        }
    }
}

export class WizardSessionData {
    constructor(savedWizard?: any) {
        if (savedWizard) {
            Object.assign(this, savedWizard);
        } else {
            this.selectedColors = [];
            this.index = 0;
        }
    }

    index: number;

    next() {
        if (this.index < 2)
            this.index++;
    }

    prev() {
        if (this.index > 0)
            this.index--;
    }

    // From the product-type page
    selectedProductUse: Dto.ProductUse = null;

    // From the product-type page
    selectedSubstrate: Dto.Substrate = null;

    // Result of product-selector/product-type
    selectedProduct: Dto.ProductType;

    // Result of product-selector/color-picker
    selectedColors: Dto.ColorType[];

    addSelectedColor(color: Dto.ColorType) {
        // If a product line was added with "no color", then remove this option since colors are being added.
        if (this.selectedColors.some(c => Dto.ColorType.isNoColor(c))) {
            this.resetSelectedColors();
        }

        if (this.selectedColors.find(c => c.colorUID == color.colorUID) == null)
            this.selectedColors.push(color);
    }
    
    resetSelectedColors() {
        this.selectedColors.forEach(c => c.isSelected = false);
        this.selectedColors = [];
    }
}
